import { render, staticRenderFns } from "./ModalCriarEditarItemSenioridade.vue?vue&type=template&id=d3304fd8&scoped=true"
import script from "./ModalCriarEditarItemSenioridade.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarItemSenioridade.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarItemSenioridade.vue?vue&type=style&index=0&id=d3304fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3304fd8",
  null
  
)

export default component.exports